import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { skipForDevelopment } from "shared/mechanics/decorators";

import { IPlugin } from "shared/mechanics/plugin";

const dsn = process.env.REACT_APP_INTEGRATION_SENTRY_DSN!;
const sampleRate = parseFloat(process.env.REACT_APP_INTEGRATION_SENTRY_SAMPLERATE!);

export interface ISentryPlugin extends IPlugin {

}

export class SentryPlugin implements ISentryPlugin {
	name: string = "Sentry";

	@skipForDevelopment
	init(): void {
		Sentry.init({
			dsn: dsn,
			integrations: [new Integrations.BrowserTracing()],
			tracesSampleRate: sampleRate,
			beforeSend: event => {
				if (event && event.message && event.message.match(/ResizeObserver/)) {
					return null;
				}

				return event;
			}
		});
	}
}